import { defineStore } from 'pinia';

export const usePageUnloadStore = defineStore('pageUnload', {
	state: () => {
		return {
			isPageUnloading: false as boolean,
		};
	},
});
